<template>
	<div
		style="padding-bottom: 16px"
	>
		<editor
			v-model="data"
			:init="config"
			license-key="gpl"
		/>
	</div>
</template>

<script>
// Module
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/models/dom/model';

// Themes & Skins
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.min.css';

// Plugins
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/link';
import 'tinymce/plugins/fullscreen';

import Editor from '@tinymce/tinymce-vue';
export default {
	name: 'TinyEditor',
	components: {
		'editor': Editor,
	},
	props:	{
		modelValue: {
			type: String,
			default: null,
		},
		height: {
			type: Number,
			default: 500
		}
	},

	emits: ['update:modelValue',],

	data () {
		return {
			data: this.modelValue,
			config: {
				height: this.height,
				menubar: false,
				plugins: 'advlist lists table link fullscreen',
				toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help | fullscreen',
				// eslint-disable-next-line camelcase
				table_toolbar: '',
				skin: false,
				// eslint-disable-next-line camelcase
				content_css: false,
			},
		};
	},

	watch: {
		data () {
			this.$emit('update:modelValue', this.data);
		},
		modelValue (newBody) {
			this.data = newBody;
		}
	},

	methods: {
	}
};
</script>
